import { TApplicationState } from "../rootReducer";

export const getAccountData = (state: TApplicationState) => {
  return {
    hasAccount: state.usersAnketa.accountData.hasAccount,
    hasAccountEmail: state.usersAnketa.accountData.hasAccountEmail,
    email: state.usersAnketa.accountData.email
  }
};